import { Component, OnInit } from '@angular/core';
import { DatePipe } from "@angular/common";
import { Http } from '@angular/http';
import { UserService } from '../_services/user.service';
import { DealersService } from '../_services/dealers.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Dealer } from '../_models/dealer';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  providers: [DealersService]
})
export class FullLayoutComponent implements OnInit {
  public userIsAdmin: boolean = false;
  public userFullname: string = "";
  public userId: string = "";
  public currentYearDate: string = "";
  public dealer: Dealer = null;
  public did: string = "";
  public errorMessage: string = "";
  private isLoading: boolean;

  constructor(private userService: UserService, private httpClient: Http, private dealersService: DealersService) {
    //alert('isadmin: '+this.userIsAdmin);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.userFullname = this.userService.getFullname();
    this.userIsAdmin = this.userService.getIsadmin();
    this.userId = this.userService.getId();
    this.currentYearDate = new DatePipe('en-US').transform(new Date(), 'y');

    //Letsgetthedealer
    if (!this.userIsAdmin) {
    this.dealersService
      .get(this.userService.getDealerId())
      .subscribe(
        /* happy path */ p => this.dealer = p,
        /* error path */ e => this.errorMessage = e,
        /* onComplete */() => {
          this.did = this.dealer._id;
          this.isLoading = false;

        });
      }
  }

  callLogout(): void {
    this.userService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts